import { render } from "./DashboardSearchBox.vue?vue&type=template&id=7201877e&scoped=true&ts=true"
import script from "./DashboardSearchBox.vue?vue&type=script&lang=ts"
export * from "./DashboardSearchBox.vue?vue&type=script&lang=ts"

import "./DashboardSearchBox.vue?vue&type=style&index=0&id=7201877e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7201877e"]])

export default __exports__